import { inject, Injectable } from '@angular/core';
import { SkuSearchResultModel } from '@libs/shop/models';
import { Observable } from 'rxjs';
import { ConnectorService } from '../connector';

@Injectable({ providedIn: 'root' })
export class SkuSearchRepositoryService {

  private readonly connector: ConnectorService = inject(ConnectorService);

  public search(productIdentifiers: string[]): Observable<SkuSearchResultModel> {
    return this.connector.connect('shop', 'skuSearch', {
      searchParams: {
        productIdentifiers,
      },
    });
  }
}
